import { FiatOrder, FIAT_ORDER, fiatFusionOrderToOrderAdapter } from '@exodus/models'

export const getUpdatedOrders = (newOrders, existingOrders) => {
  const ordersToUpdate = []
  const ordersToAdd = []

  for (const order of newOrders) {
    const existingOrder = existingOrders.get(order)

    if (existingOrder && !existingOrder.equals(order)) {
      ordersToUpdate.push(order)
    } else if (!existingOrder) {
      ordersToAdd.push(order)
    }
  }

  if (ordersToUpdate.length === 0 && ordersToAdd.length === 0) {
    return
  }

  let updatedOrders = existingOrders

  if (ordersToUpdate.length > 0) {
    updatedOrders = updatedOrders.update(ordersToUpdate)
  }

  if (ordersToAdd.length > 0) {
    for (const order of ordersToAdd) {
      updatedOrders = updatedOrders.add(order)
    }
  }

  return updatedOrders
}

const getStatusOverride = (order) => {
  try {
    return ['failed', 'complete'].includes(order.exodusStatus)
      ? order.status
      : FIAT_ORDER.STATUS_MAP[order.provider].failed[0]
  } catch {
    return order.status
  }
}

export const validateOrder = (order, existingOrders, assets) => {
  const existing = existingOrders.get(order.orderId)
  const canMonitor = !['prime-trust', 'wyre'].includes(order.provider)

  if (existing && canMonitor) {
    if (existing.synced) {
      return
    }

    return { ...existing.toJSON(), synced: true }
  }

  const fiatOrder = FiatOrder.fromJSON(fiatFusionOrderToOrderAdapter(order, assets))

  return {
    ...fiatOrder,
    status: canMonitor ? 'e2e-syncing' : getStatusOverride(fiatOrder),
  }
}
